import GaEvent from './GaEvent';

export default class ItineraryCreatedGaEvent extends GaEvent {
  constructor() {
    super('itinerary_created');
  }

  addItineraryId(value: number | string) {
    this.addParam('itinerary_id', String(value));

    return this;
  }

  addItineraryName(value: string) {
    this.addParam('itinerary_name', value);

    return this;
  }
}
